/**
 * SearchStep — Creative Studio wrapper around the shared business search entry.
 *
 * Keeps its existing prop interface unchanged so CreativesStudio.jsx
 * needs zero changes while sharing the exact entry structure with
 * other portal flows that start from business selection.
 */
import React from 'react';
import BusinessSearchExperience from '../BusinessSearchExperience';

const SearchStep = ({
  searchMethod,
  setSearchMethod,
  selectedPlaceId,
  realBusinessData,
  isScraping,
  apiError,
  currentOrg,
  selectedAdvertiserId,
  setSelectedAdvertiserId,
  onPlaceSelect,
  onStartScraping,
}) => {
  return (
    <BusinessSearchExperience
      title="Spotlight Your Business"
      subtitle="Search for your business to instantly generate professional, TV-ready video campaigns."
      searchMethod={searchMethod}
      setSearchMethod={setSearchMethod}
      selectedPlaceId={selectedPlaceId}
      selectedBusiness={realBusinessData}
      isLoading={isScraping}
      error={apiError}
      currentOrg={currentOrg}
      selectedAdvertiserId={selectedAdvertiserId}
      setSelectedAdvertiserId={setSelectedAdvertiserId}
      onPlaceSelect={onPlaceSelect}
      onSubmitSource={onStartScraping}
      ctaLabel="Analyze Business"
      ctaLoadingLabel="Analyzing..."
      footerSlot={
        <p className="text-xs text-center text-muted-foreground pt-2 opacity-50">
          Powered by AI &bull; Instant Generation &bull; TV-Ready Quality
        </p>
      }
    />
  );
};

export default SearchStep;
